import React from 'react'
import CampaignList from '../campaign-list'
import PlanList from '../plans'

const Acquisition = () => {
  return (
    <>
      <PlanList />
      <CampaignList />
    </>
  )
}

export default Acquisition
